import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators/map';

@Injectable()
export class HttpService {

  constructor(
    private http: HttpClient
  ) { }

  get(url: string, options: any = {}) {
    return this.http.get<any>(url, options).pipe(map((res: any) => res.data));
  }

  getRaw(url: string, options: any = {}): any {
    return this.http.get<any>(url, options);
  }

  getIPAddress() {
    return this.getRaw('https://api.ipify.org/?format=json');
  }

  post(url: string, data: any = {}, options: any = {}) {
    return this.http.post<any>(url, data, options).pipe(map((res: any) => res.result));
  }

  postRaw(url: string, data: any = {}, options: any = {}): any {
    return this.http.post<any>(url, data, options);
  }

  upload(url: string, file, fileName) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('fileName', fileName);
    return this.http.post(url, fd);
  }

  put(url: string, data: any = {}, options: any = {}) {
    return this.http.put<any>(url, data, options).pipe(map((res: any) => res.result));
  }

  delete(url: string, options: any = {}) {
    return this.http.delete(url, options).pipe(map((res: any) => res.result));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/http.service.ts